import { filter, forEach, includes, isEmpty, join, size, some } from 'lodash'

import { PUNCTUATION_MARKS } from '../../../constants'

const validatePhrase = (
  phraseToValidate,
  dependencies,
  validationOptions = {
    conflicting: true,
    placeholderExisting: true,
    placeholderNumber: 1,
    incompletePlaceholder: true,
  },
) => {
  const {
    conflicting,
    placeholderExisting,
    placeholderNumber,
    incompletePlaceholder,
  } = validationOptions

  if (conflicting) {
    const conflictingPhrases = filter(phraseToValidate, phrase =>
      some(dependencies, dependencyField => includes(dependencyField, phrase)),
    )

    if (!isEmpty(conflictingPhrases)) {
      throw new Error(
        `Phrases already exist in the other fields: ${join(
          conflictingPhrases,
          ' ; ',
        )}`,
      )
    }
  }

  forEach(phraseToValidate, phrase => {
    if (
      some(PUNCTUATION_MARKS, punctuationMark =>
        includes(phrase, punctuationMark),
      )
    ) {
      throw new Error(`Phrase cannot contain punctuation marks: ${phrase}`)
    }

    const placeholderMatches = phrase.match(/\{.*?\}/g)

    if (isEmpty(placeholderMatches) && placeholderExisting) {
      throw new Error(`No placeholder found for phrase: ${phrase}`)
    }

    if (size(placeholderMatches) > placeholderNumber) {
      throw new Error(
        `2 placeholders for a single phrase is not allowed: ${phrase}`,
      )
    }

    if (some(placeholderMatches, placeholder => placeholder !== '{}')) {
      throw new Error(
        `Phrase can't contain something in placeholder: ${phrase}`,
      )
    }

    if (phrase === '{}') {
      throw new Error("Phrase can't be just the placeholder")
    }

    if (incompletePlaceholder) {
      const phraseWithoutBracketPairs = phrase.replace(/\{.*?\}/g, '')

      if (
        includes(phraseWithoutBracketPairs, '{') ||
        includes(phraseWithoutBracketPairs, '}')
      ) {
        throw new Error(
          `Incomplete bracket pair detected for phrase: ${phrase}`,
        )
      }
    }
  })
}

export default validatePhrase
